import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Avatars from 'assets/avatars'
import KidsModal from './KidsModal'

const KidsCard = ({ kid, callbacks }) => {
  const [showModal, setShowModal] = useState(false)
  const { name, balance, avatar } = kid

  return (
    <div className="w-1/3 px-2 mb-4">
      <div
        onClick={() => setShowModal(true)}
        className="flex items-center flex-1 p-4 duration-500 bg-white rounded-lg shadow-sm cursor-pointer hover:shadow-lg transition:all"
      >
        <div className="flex items-center">
          <div className="mr-4 avatar">
            <img src={Avatars[avatar]} alt="Avatar" />
          </div>
          <div className="text-2xl font-light">{name}</div>
        </div>
        <div className="ml-auto text-xl text-pink-400">
          <span className="font-bold">{balance}</span>
          <span> points</span>
        </div>
      </div>
      {showModal ? (
        <KidsModal
          kid={kid}
          show={showModal}
          setShow={setShowModal}
          callbacks={callbacks}
        />
      ) : null}
    </div>
  )
}

KidsCard.propTypes = {
  kid: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    balance: PropTypes.number,
    avatar: PropTypes.string,
  }),
  callbacks: PropTypes.shape({
    edit: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
  }),
}

export default KidsCard
